import type { CInteractiveMapTranslations } from "./pl";

export const de: CInteractiveMapTranslations = {
  search: "Suchen",
  empty: "Keine Daten zum Anzeigen.",
  emptyMap: "Die Karte wurde noch nicht konfiguriert.",
  noResults: "Keine Suchergebnisse.",
};
